<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Spider Account</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by Name</u></label>
        <input type="text" [(ngModel)]="filterable.name" class="form-control" placeholder="enter name" />
      </div>
      <div class="col ml-auto text-right  align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-outline-success btn-sm text-dark font-weight-bold" (click)="openModal(newAccountModal)" *ngIf="currentUser.roleName == 'ADMIN'">+ Account </button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<table id="spiderList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>NO.</th>
      <th>Source</th>
      <th>Name</th>
      <th>Label</th>
      <th>Partner ID</th>
      <th>Partner Key</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="16">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="16">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let account of accountList; index as i;">
      <td>{{i + 1}}</td>
      <td>{{account.sourceView}}</td>
      <td>{{account.name}}</td>
      <td>
        <span *ngIf="account.label != null">{{account.label}}</span>
        <span *ngIf="account.label == null">-</span>
      </td>
      <td>{{account.partnerId}}</td>
      <td>{{account.apiKey}}</td>
      <td>
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/spider/account-detail', account.id]" *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteAccount(account)"  *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="16" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newAccountModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newAccountLabel">New Account</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newAccount-modal-body">
    <form [formGroup]="newAccountForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">
        <div class="col-sm-12">
          <label for="source" class="col-form-label"><span class="text-danger">* </span>Source: </label>
          <select class="form-control" placeholder="Select" formControlName="source">
            <option value=null>-select source-</option>
            <option *ngFor="let source of sourceList | keyvalue" [value]="source.value">{{source.key}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.name.errors">
              The Source cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="name" class="col-form-label"><span class="text-danger">* </span>Name: </label>
          <input type="text" class="form-control" formControlName="name" placeholder="Name">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.name.errors">
              The name cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="label" class="col-form-label">Label: </label>
          <input type="text" class="form-control" formControlName="label" placeholder="label">
        </div>
        <div class="col-sm-12">
          <label for="partnerId" class="col-form-label">Partner ID: </label>
          <input type="text" class="form-control" formControlName="partnerId" placeholder="Partner ID">
        </div>
        <div class="col-sm-12">
          <label for="apiKey" class="col-form-label">Api Key: </label>
          <input type="text" class="form-control" formControlName="apiKey" placeholder="Api Key">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add Account</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
